// tab ids
const NEW_TAB_ID = 'new';
const PEER_TAB_ID = 'peer';
const APPROVAL_TAB_ID = 'approval';
const REJECTED_TAB_ID = 'rejected';
const CIRCUITCHECK_TAB_ID = 'circuitchecks';
const PRECLOSURE_TAB_ID = 'preclosure';
const EMERGENCY_TAB_ID = 'emergency';

const DEFAULT_TAB = NEW_TAB_ID;

const PENDING_PEER_REVIEW = 'new';
const PENDING_APPROVALS = 'peer';
const INITIAL_COMMS_SENT = 'approval';
const FULLY_APPROVED = 'rejected';
const PENDING_CLOSURE = 'circuitchecks';

// const DEFAULT_TAB = PENDING_PEER_REVIEW;

export {
  NEW_TAB_ID,
  PEER_TAB_ID,
  CIRCUITCHECK_TAB_ID,
  APPROVAL_TAB_ID,
  REJECTED_TAB_ID,
  DEFAULT_TAB,
  PRECLOSURE_TAB_ID,
  PENDING_PEER_REVIEW,
  PENDING_APPROVALS,
  INITIAL_COMMS_SENT,
  FULLY_APPROVED,
  PENDING_CLOSURE,
  EMERGENCY_TAB_ID,
  // DEFAULT_TAB,
};
